// extracted by mini-css-extract-plugin
module.exports = {"indexPage":"IndexPage_indexPage__eMyQ7","contentBottom":"IndexPage_contentBottom__FJeYm"};